import { BehaviorSubject } from "rxjs";
import { IWidgetSymbol } from "../../models/IWidgetSymbol";

export const mostActiveWatchListSymbols$ = new BehaviorSubject<string[]>([]);

export const removeWatchListSymbol$ = new BehaviorSubject<IWidgetSymbol>({ widgetId: '', symbol: '' });

export const trade2BWatchListSymbols$ = new BehaviorSubject<string[]>([]);
